import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { OTPGeneration } from '../models/otp.model';
@Injectable({
  providedIn: 'root'
})
export class OtpService {
  
  private lineServiceUrl: string = environment.endpointBackend + '/api/line';

  constructor(private http: HttpClient) { }

  generateOTP(payload:OTPGeneration){
    return this.http.post(this.lineServiceUrl + '/send/otp', payload);
  }
}
